module.exports = __webpack_public_path__ + "static/media/pexels-tima-miroshnichenko-6766284.608220c5.jpg";